import Api from "./index";
import { endPoints, requestType } from "../constants/Variables";

export const fetchClients = (id) => {
  return Api(endPoints.fetchClients, id, requestType.POST);
};
